import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FullscreenService {
    private fullScreenStatus = new Subject<any>();

    constructor() {}

    setFullScreenStatus(message) {
        this.fullScreenStatus.next(message);
    }

    getFullScreenStatus(): Observable<any> {
        return this.fullScreenStatus.asObservable();
    }
}
